module.exports = __webpack_public_path__ + "static/media/tick-green.0ec337cd.svg";